<template>
  <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Profile Characters</h5>
          <span aria-hidden="true" role="button" @click="close"><i class="fas fa-xmark"></i></span>
        </div>
        <div class="modal-body">
          <Spinner v-if="this.isLoading">{{ this.loadingtext }}</Spinner>
          <data-table v-else :actions="actions" :headers="headers" :items="this.characters" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">
            Close
          </button>
        </div>
      </div>
    </div>
    <EquipmentsModal :data="this.equipmentData" v-if="this.equipmentData.show" :api="this.api" :server="this.server">
    </EquipmentsModal>
    <CharacterAuditModal :data="this.auditData" v-if="this.auditData.show" :api="this.api" :server="this.server">
    </CharacterAuditModal>
  </div>
</template>

<script>
  import DataTable from "data-table/src/components/DataTable";
  import EquipmentsModal from "./EquipmentsModal";
  import CharacterAuditModal from "./CharacterAuditModal.vue";
  import Spinner from "./Loaders/Spinner.vue";
  export default {
    name: "ProfileCharacterModal",
    data() {
      return {
        trigger: {},
        orderid: "",
        coinValue: 20,
        showAdd: false,
        showReward: false,
        products: [],
        headers: {
          id: "ID",
          name: "Name",
          equipmentCount: "Equipment Count"
        },
        isLoading: false,
        loadingtext: "Fetching Characters",
        actions: [
          // {
          //   classNames: "fas fa-clipboard-list text-danger",
          //   callback: this.audits,
          // },
          {
            classNames: "fa-solid fa-shield text-warning",
            callback: this.equipments,
          },
        ],
        characters: {},
        equipmentData: {
          show: false,
          entity: null,
        },
        auditData: {
          show: false,
          entity: null,
        },
        itemsData: {
          show: false,
          entity: null,
        },
      };
    },
    props: {
      data: {
        entity: Object,
        show: Boolean,
      },
      api: Object,
      server: Number,
    },
    components: {
      DataTable,
      EquipmentsModal,
      Spinner,
      CharacterAuditModal,
    },
    methods: {
      async equipments(entity) {
        this.equipmentData.entity = entity;
        this.equipmentData.show = true;
        this.equipmentData.isAdd = true;
      },
      async audits(entity) {
        this.auditData.entity = entity;
        this.auditData.show = true;
      },
      async items(entity) {
        this.itemsData.entity = entity;
        this.itemsData.profile_id = this.data.entity._id;
        this.itemsData.show = true;
        this.itemsData.isAdd = true;
      },
      async getCharacters() {
        this.isLoading = true;
        this.characters = await this.api.charlist.getCharacters(
          this.data.entity._id,
          this.server
        );
        this.loadingtext = "Loading other informations"
        for (const char of this.characters) {
          let res = await this.api.charequipment.getCharacterEquipmentCount(char.id, this.server, 0, 10)
          char.equipmentCount = res.count;
        }
        this.isLoading = false;
      },
      closeAdd() {
        this.showAdd = false;
        this.showReward = false;
      },
      close() {
        let data = this.data;
        data.show = false;
      },
    },
    async created() {
      this.getCharacters();
    },
    async mounted() { },
  };
</script>

<style scoped></style>
